import React, { Component } from 'react'
import { Menu, Icon } from 'antd'
import { Link } from 'react-router-dom'
import { PermissionService } from 'services/PermissionService'
import { Permissions } from 'permissions'
import './Navbar.scss'

const MenuItem = Menu.Item
const MenuSubMenu = Menu.SubMenu

export class Navbar extends Component<{ tenant: string }>
{
  pathName: string;
  basepath: string;

  componentDidMount() {
    this.pathName = window.location.pathname;
    this.basepath = this.pathName.lastIndexOf('/') != 0 ? this.pathName.slice(0, this.pathName.lastIndexOf('/')) : this.pathName;
  }

  isMenuItemDisabled = (permissionRequired: string): boolean => {
    return !PermissionService.hasPermission(permissionRequired)
  }

  render() {
    return (
      <Menu id="navbar" theme="dark" mode="inline" defaultSelectedKeys={[this.pathName]} defaultOpenKeys={[this.basepath]}>
        <MenuItem>
          <Link to="/">
            <Icon type="audit" theme="outlined" />
            <span>Cluster: {this.props.tenant}</span>
          </Link>
        </MenuItem>
        <MenuItem key="/">
          <Link to="/">
            <Icon type="home" />
            <span>Home</span>
          </Link>
        </MenuItem>
        <MenuSubMenu key="/organization" title={<span><Icon type="bank" />Organization</span>}>
          <MenuItem key="/organization/search" disabled={this.isMenuItemDisabled(Permissions.Organization_Search__Read)}>
            <Link to="/organization/search">
              <Icon type="search" />
              <span>Search</span>
            </Link>
          </MenuItem>
          <MenuItem key="/organization/create" disabled={this.isMenuItemDisabled(Permissions.Organization_Create)}>
            <Link to="/organization/create">
              <Icon type="plus-circle" />
              <span>Create</span>
            </Link>
          </MenuItem>
          <MenuItem key="/organization/bulkInsert" disabled={this.isMenuItemDisabled(Permissions.Organization_Create)}>
            <Link to="/organization/bulkInsert">
              <Icon type="file-text" />
              <span>Bulk Insert</span>
            </Link>
          </MenuItem>
          <MenuItem key="/organization/organizationteam" disabled={this.isMenuItemDisabled(Permissions.Organization_Team__Read)}>
            <Link to="/organization/team/organizationteam">
              <Icon type="team" />
              <span>Organization Team</span>
            </Link>
          </MenuItem>
          <MenuItem key="/organization/sso" disabled={this.isMenuItemDisabled(Permissions.Organization_Create)}>
            <Link to="/organization/sso">
              <Icon type="team" />
              <span>SSO</span>
            </Link>
          </MenuItem>
          <MenuItem key="/organization/reset-mfa" disabled={this.isMenuItemDisabled(Permissions.Organization_Reset_Mfa)}>
            <Link to="/organization/reset-mfa">
              <Icon type="reload" />
              <span>Reset MFA</span>
            </Link>
          </MenuItem>
        </MenuSubMenu>
        <MenuSubMenu key="/application" title={<span><Icon type="robot" />Chatbot</span>}>
          <MenuItem key="/application" disabled={this.isMenuItemDisabled(Permissions.Application_Overview__Read)}>
            <Link to="/application">
              <Icon type="robot" />
              <span>Overview</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/clone" disabled={this.isMenuItemDisabled(Permissions.Application_Clone)}>
            <Link to="/application/clone">
              <Icon type="copy" />
              <span>Clone</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/campaign" disabled={this.isMenuItemDisabled(Permissions.Application_Overview__Read)}>
            <Link to="/application/campaign">
              <Icon type="calculator" />
              <span>Active Campaign</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/migrate" disabled={this.isMenuItemDisabled(Permissions.Application_Migrate)}>
            <Link to="/application/migrate">
              <Icon type="import" />
              <span>Migrate</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/analytics" disabled={this.isMenuItemDisabled(Permissions.Application_Analytics)}>
            <Link to="/application/analytics">
              <Icon type="dashboard" />
              <span>Analytics</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/desk" disabled={this.isMenuItemDisabled(Permissions.Application_Desk)}>
            <Link to="/application/desk">
              <Icon type="customer-service" />
              <span>Desk</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/configurations" disabled={this.isMenuItemDisabled(Permissions.Application_Configurations__Read)}>
            <Link to="/application/configurations">
              <Icon type="setting" />
              <span>Configurations</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/team" disabled={this.isMenuItemDisabled(Permissions.Application_Team)}>
            <Link to="/application/team">
              <Icon type="team" />
              <span>Team</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/builder" disabled={this.isMenuItemDisabled(Permissions.Application_Builder)}>
            <Link to="/application/builder">
              <Icon type="build" />
              <span>Builder</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/contacts" disabled={this.isMenuItemDisabled(Permissions.Application_Contacts_Info)}>
            <Link to="/application/contacts">
              <Icon type="user" />
              <span>Contacts</span>
            </Link>
          </MenuItem>
          <MenuItem key="/application/bothealth" disabled={this.isMenuItemDisabled(Permissions.Application_Overview__Read)}>
            <Link to="/application/bothealth">
              <Icon type="heart" />
              <span>Bot Health</span>
            </Link>
          </MenuItem>
          <MenuSubMenu key="/application/channels" title={<span><Icon type="global" />Channels</span>}>
            <MenuItem key="/application/sms" disabled={this.isMenuItemDisabled(Permissions.Application_Channels_Sms_Read)}>
              <Link to="/application/sms">
                <Icon type="wechat" />
                <span>SMS</span>
              </Link>
            </MenuItem>
            <MenuItem key="/application/whatsapp" disabled={this.isMenuItemDisabled(Permissions.Application_Overview__Read)}>
              <Link to="/application/whatsapp">
                <Icon type="appstore" />
                <span>Whatsapp</span>
              </Link>
            </MenuItem>
          </MenuSubMenu>
        </MenuSubMenu>
        <MenuSubMenu key="/statuspage" title={<span><Icon type="database" />Support</span>}>
          <MenuItem key="/statuspage" disabled={this.isMenuItemDisabled(Permissions.Application_StatusPage__Read)}>
            <Link to="/statuspage">
              <Icon type="alert" />
              <span>Status Page</span>
            </Link>
          </MenuItem>
          <MenuItem key="/messages" disabled={this.isMenuItemDisabled(Permissions.Application_Messages__Read)}>
            <Link to="/messages">
              <Icon type="notification" />
              <span>Messages</span>
            </Link>
          </MenuItem>
          <MenuItem key="/procedure" disabled={this.isMenuItemDisabled(Permissions.Procedures)}>
            <Link to="/procedure">
              <Icon type="bars" />
              <span>Procedure</span>
            </Link>
          </MenuItem>
        </MenuSubMenu>
        <MenuItem key="/scheduler" disabled={this.isMenuItemDisabled(Permissions.Scheduler)}>
          <Link to="/scheduler">
            <Icon type="clock-circle" />
            <span>Scheduler</span>
          </Link>
        </MenuItem>
        <MenuItem key="/images" disabled={this.isMenuItemDisabled(Permissions.Images)}>
          <Link to="/images">
            <Icon type="delete" />
            <span>Images</span>
          </Link>
        </MenuItem>
        <MenuItem key="/account" disabled={this.isMenuItemDisabled(Permissions.Account)}>
          <Link to="/account">
            <Icon type="user" />
            <span>Account</span>
          </Link>
        </MenuItem>
        <MenuItem key="/billing" disabled={this.isMenuItemDisabled(Permissions.Billing)}>
          <Link to="/billing">
            <Icon type="file-done" />
            <span>Billing</span>
          </Link>
        </MenuItem>
        <MenuItem key="/cloud">
          <Link to="/cloud">
            <Icon type="cloud" />
            <span>Cloud</span>
          </Link>
        </MenuItem>
        <MenuItem key="/adminidentity" disabled={this.isMenuItemDisabled(Permissions.Admin_Identity_Access_Key)}>
          <Link to="/adminidentity">
            <Icon type="crown" />
            <span>Admin Identity</span>
          </Link>
        </MenuItem>
      </Menu>
    )
  }
}
